import React from 'react';
import { DiamondIcon } from 'app/components/icons';
import { BaseButton } from 'app/components/buttons/BaseButton';
import './SubscriptionRow.less';

interface Props {
  label: string;
  buttonLabel: string;
  onClick: () => void;
}

export default function SubscriptionRow({
  label,
  buttonLabel,
  onClick,
}: Props) {
  return (
    <div className="subscription-row">
      <DiamondIcon />

      <span className="subscription-row__description">{label}</span>

      <BaseButton className="subscription-row__action-button" onClick={onClick}>
        {buttonLabel}
      </BaseButton>
    </div>
  );
}
